import { useSettingsStore } from "@/stores/settingsStore";
import { toRefs } from "vue";

export function useSettings() {
  const settings = useSettingsStore();
  return toRefs(settings);
}
